import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {SearchService} from '../search.service';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {ResultDetails} from './result-details';

@Injectable({
  providedIn: 'root'
})
export class FulltextService {

  private baseUrl = "apiUrl";

  constructor(private searchService: SearchService, private http: HttpClient) {
  }

  public getMaterializationsByObjectIdsAndQuery(objectIds: number[], query: string): Observable<ResultDetails[]> {
    const url = `${this.baseUrl}/omnis/search/fulltext`;

    return this.http.get<ResultDetails[]>(url, {
      params: {
        query: query,
        objectIds: objectIds.join(',')
      }
    });
  }
}
